//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 01/04/2025
// Version : 1
// Description : pantalla de tareas que esta dentro de servicios en la de carga (no info)
//------Changes --------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useEffect, useState, useMemo } from "react";
import { UrlApi } from "../../services/apirest";
import {
  Container,
  Typography,
  Tooltip,
  IconButton,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Grid,
  DialogTitle,
} from "@mui/material";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import BlockIcon from "@mui/icons-material/Block";
import EditIcon from "@mui/icons-material/Edit";
import Notify from "../Notify";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { logEventos } from "../../services/services";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import moment from "moment";
import Agregar_tarea from "./Agregar_tarea";
import RepuestosTareas from "./RepuestosTareas";
import Checklist from "./Checklist";
import EditarTarea from "./EditarTarea";

function TareasServicio(props) {
  const [tarea, setTarea] = useState([]);
  const [datosTanque, setDatosTanque] = useState(props.datos); // viene de tanque rehab
  const [datosTarea, setDatosTarea] = useState({});
  const globalTheme = useTheme();
  const [tablaTAREA, setTablaTAREA] = useState(true);
  const [altaTAREA, setAltaTAREA] = useState(false); //Estado q mostrará o no la pantalla de alta
  const [tabla, setTabla] = useState(true);
  const [row, setRow] = useState(props.row);
  const [confirmar, setConfirmar] = useState(false);
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [openSnack, setOpenSnack] = React.useState(false); //abre y cierra snack
  const [mensaje, setMensaje] = useState(""); //mensaje q mostrará la notif
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
  const [obt, setObt] = useState(0);
  const [checklist, setChecklist] = useState(false);
  const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de choferes
  const [update, setUpdate] = useState(false);
  //  //    //acceso al menu
  useEffect(() => {
    logEventos(
      "Acceso al menú tareas",
      "Tanques Moviles",
      "Agregar,editar,activar o desactivar una tarea y agregar tareas",
      localStorage.getItem("user")
    );
  }, []);
  useEffect(() => {
    if (props.datos) {
      setDatosTanque(props.datos);
    }
  }, [props.datos]);

  const obtenerTareas = () => {
    fetch(
      UrlApi + "/tanque_tarea/tareaXtanqueYservicio/" + row.original.id_servicio
    )
      .then((data) => data.json())
      .then((data) => setTarea(data));
  };

  useEffect(() => {
    obtenerTareas();
  }, [tabla, obt, confirmar]);

  // para actualizar
  useEffect(() => {
    if (update) {
      obtenerTareas();
      setUpdate(false);
    }
  }, [update]);

  const abrirModalConfirmar = (datosDeLaLinea) => {
    setConfirmar(true);
    setDatosTarea(datosDeLaLinea);
  };

  const handleVolver = () => {
    setConfirmar(false);
    setTablaTAREA(true);
  };

  // columnas tabla
  const columns = useMemo(
    () => [
      {
        header: "Desde",
        accessorFn: (desde) => moment(desde.tarea_desde).format("DD-MM-YYYY"),
        size: 45,
      },
      {
        header: "Hasta",
        accessorFn: (hasta) => moment(hasta.tarea_hasta).format("DD-MM-YYYY"),
        size: 45,
      },
      {
        header: "Motivo",
        accessorKey: "motivo_tarea",
        size: 100,
        Cell: ({ cell }) => (
          <Tooltip
            title={
              <span style={{ whiteSpace: "pre-wrap" }}>{cell.getValue()}</span>
            }
            arrow
            placement="top-start"
            enterDelay={300}
            leaveDelay={200}
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
            }}
            slotProps={{
              tooltip: {
                sx: {
                  maxWidth: 700,
                  bgcolor: "rgb(181,181,179,0.95)",
                  color: "black",
                  fontSize: "1rem",
                  p: 2.5,
                  borderRadius: 2,
                },
              },
            }}
          >
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: 300,
                cursor: "help",
              }}
            >
              {cell.getValue()}
            </div>
          </Tooltip>
        ),
      },
      {
        header: "Detalle",
        accessorKey: "detalle_tarea",
        size: 100,
        Cell: ({ cell }) => (
          <Tooltip
            title={
              <span style={{ whiteSpace: "pre-wrap" }}>{cell.getValue()}</span>
            }
            arrow
            placement="top-start"
            enterDelay={300}
            leaveDelay={200}
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
            }}
            slotProps={{
              tooltip: {
                sx: {
                  maxWidth: 700,
                  bgcolor: "rgb(181,181,179,0.95)",
                  color: "black",
                  fontSize: "1rem",
                  p: 2.5,
                  borderRadius: 2,
                },
              },
            }}
          >
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: 200,
                cursor: "help",
              }}
            >
              {cell.getValue()}
            </div>
          </Tooltip>
        ),
      },

      {
        header: "Encargado",
        accessorKey: "razon_social",
        size: 100,
      },
      {
        header: "Es",
        accessorKey: "estado_palabra_proviene",
        size: 40,
      },
      {
        header: "Finalizada",
        accessorKey: "estado_palabra_finalizada",
        size: 40,
      },
    ],
    []
  );
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode, //let's use the same dark/light mode as the global theme
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)" //background in light mode
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem", //override to make tooltip font size larger
              },
            },
          },
        },
      }),
    [globalTheme]
  );
  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };
  const initialState = {
    //para inicializar la tabla, y la cantidad de paginas q se ven ej 5
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };
  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 14,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const marcarInactivo = async (e) => {
    logEventos(
      "Marca fin una tarea",
      "Tanques Moviles",
      "Se finalizo la tarea",
      localStorage.getItem("user")
    );
    e.preventDefault();
    const response = await fetch(
      UrlApi + "/tanque_tarea/" + datosTarea.id_tarea,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(
          datosTarea.finalizada === 0 ? { finalizada: 1 } : { finalizada: 0 }
        ),
      }
    );
    if (response.ok === false) {
      const error = response && response.json();
      setError(error);
      alert("Inconvenientes con la API. No se pudo guardar. ");
    } else {
      try {
        const json = await response.json();
        if (json.message) {
          setNotificacion(true);
          setOpenSnack(true);
          setMensaje(
            json.message === "OK" ? "Guardado" : "Guardado. Actualizar RTA Api."
          );
          obtenerTareas();
        } else if (json.sqlMessage) {
          json && setError(json);
          alert("SQL erróneo (" + json.code + " Errno: " + json.errno + " )");
        } else {
          alert("ERROR DESCONOCIDO.");
        }
      } catch (error) {
        if (error.toString().includes("is not valid JSON")) {
          setNotificacion(true);
          setOpenSnack(true);
          setMensaje("Guardado");
          obtenerTareas();
        } else {
          alert("Error: " + error);
        }
      }
    }
    handleVolver();
    obtenerTareas();
  };

  const handleCloseAdd = () => {
    setAltaTAREA(false);
    setUpdate(true);
    setTabla(true);
    obtenerTareas();
  };

  const handleClickNuevaTarea = () => {
    setAltaTAREA(true);
    setTabla(false);
  };

  const mostrarChecklist = () => {
    setChecklist(true);
    // setTabla(false);
    setDatosTanque();
  };
  const handleCloseChecklist = () => {
    setTabla(true);
    setChecklist(false);
    //setUpdate(true);
    obtenerTareas();
  };

  const handleCloseEditar = () => {
    setEditar(false);
    setUpdate(true);
    setTabla(true);
    obtenerTareas();
  };

  const customLocalization = {
    ...MRT_Localization_ES,
    expand: "Exp", // <- Cambiás "Expandir" por "Exp"
  };

  const mostrareditar = (datosDeLaLinea) => {
    setEditar(true);
    setTabla(false);
    setDatosTarea(datosDeLaLinea);
    // console.log("datos linea", datosDeLaLinea ? datosDeLaLinea : "NO");
  };

  return (
    <div>
      <br></br>
      <br></br>
      <Container maxWidth={false} disableGutters sx={{ mt: 1, mb: 2 }}>
        {tarea && tablaTAREA ? (
          <Box boxShadow={3}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableColumnResizing
                columns={columns}
                data={tarea}
                initialState={initialState}
                positionActionsColumn="last"
                enableExpandAll={false}
                enableToolbarInternalActions={true}
                muiTableHeadCellProps={tableHeadCellProps}
                muiTableBodyCellProps={({ row }) => ({
                  align: "left",
                  sx: {
                    p: "0px 0px", // padding: 0 arriba/abajo, 4px izq/der
                    fontSize: "0.85rem",
                    lineHeight: 1,
                    backgroundColor:
                      row.original.finalizada === 0 ? "#efc3c3" : "#b3e6b3",
                    color: "black",
                    borderColor: "black",
                  },
                })}
                enableColumnActions={false}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                enableDensityToggle={false}
                renderTopToolbarCustomActions={() => (
                  <>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AddBoxTwoToneIcon />}
                      onClick={handleClickNuevaTarea}
                      size="small"
                    >
                      Agregar Tarea
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      startIcon={<AddBoxTwoToneIcon />}
                      onClick={mostrarChecklist}
                      size="small"
                    >
                      Agregar Checklist
                    </Button>
                    <Typography variant="poster" fontSize={20}>
                      Tareas del Servicio
                    </Typography>
                  </>
                )}
                layoutMode="grid"
                localization={customLocalization}
                enableColumnDragging={false} //No permite que se arrastren las columnas.
                enableEditing
                // ACCIONES
                renderToolbarInternalActions={(
                  { table } // boton para nuevo , al lado del buscar
                ) => (
                  <>
                    <MRT_FullScreenToggleButton table={table} />
                  </>
                )}
                renderDetailPanel={({ row }) => (
                  <div style={{ marginTop: "-50px" }}>
                    <Box
                      sx={{
                        width: "200%",
                      }}
                    >
                      <RepuestosTareas tareasXtanque={row.original} />
                    </Box>
                  </div>
                )}
                renderRowActions={(
                  { row } //las acciones del costado editar y ver
                ) => (
                  <div>
                    <Tooltip arrow placement="left" title="Editar tarea">
                      <IconButton
                        onClick={() => mostrareditar(row.original)}
                        color="primary"
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                    {row.original.finalizada === 0 ? (
                      <Tooltip title="Marcar como NO finalizada">
                        <IconButton
                          color="success"
                          onClick={() => abrirModalConfirmar(row.original)}
                        >
                          <CheckCircleOutlineIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Marcar como finalizada">
                        <IconButton
                          onClick={() => abrirModalConfirmar(row.original)}
                          color="error"
                        >
                          <BlockIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                )}
              />
            </ThemeProvider>
            <br />
            <br />
          </Box>
        ) : null}

        {confirmar ? (
          <div>
            <Dialog open={confirmar} onClose={handleVolver}>
              <form onSubmit={marcarInactivo}>
                <Box backgroundColor={"#1F618D"}>
                  <DialogTitle>
                    {datosTarea.finalizada === 0 ? (
                      <Typography variant="h6" align="center" color="#ffffff">
                        No finalizar {datosTarea.motivo_tarea}
                      </Typography>
                    ) : (
                      <Typography variant="h6" align="center" color="#ffffff">
                        Finalizar {datosTarea.motivo_tarea}
                      </Typography>
                    )}
                  </DialogTitle>
                </Box>
                <DialogContent>
                  <DialogContentText textAlign={"center"}>
                    {datosTarea.finalizada === 0 ? (
                      <> ¿Desea NO finalizar la tarea ? </>
                    ) : (
                      <> ¿Desea finalizar la tarea ? </>
                    )}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItemns="center"
                  >
                    <Button
                      variant="contained"
                      onClick={handleVolver}
                      style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
                    >
                      Cancelar
                    </Button>
                    <Button
                      style={{ backgroundColor: "#2e7d32", color: "#ffffff" }}
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      Confirmar
                    </Button>
                  </Grid>
                </DialogActions>
              </form>
            </Dialog>
          </div>
        ) : null}
        {notificacion ? (
          <Notify
            mensaje={mensaje}
            open={openSnack}
            color={"#D4EFDF"}
            severity={"success"}
            handleClose={handleVolver}
          />
        ) : null}
        {altaTAREA ? (
          <Agregar_tarea
            datos={datosTanque}
            alta={setAltaTAREA}
            tabla={setTabla}
            onClose={handleCloseAdd}
            row={row}
          />
        ) : null}
        {checklist ? (
          <Checklist
            checklist={checklist}
            tabla={setTabla}
            datos={datosTanque}
            tareasAgregadas={tarea}
            row={row}
            onClose={handleCloseChecklist}
          ></Checklist>
        ) : null}
        {editar ? (
          <EditarTarea
            editar={setEditar}
            tabla={setTabla}
            datos={datosTarea}
            actualizar={setObt}
            row={row}
            onClose={handleCloseEditar}
          ></EditarTarea>
        ) : null}
      </Container>
    </div>
  );
}

export default TareasServicio;
